import { InjectionToken } from "@angular/core";
import { CompanyParametersPort } from "./company-parameters.port";

export const COMPANY_PARAMETERS_PORT =
  new InjectionToken<CompanyParametersPort>("COMPANY_PARAMETERS_PORT");
